import {
  ModbusReadRegisterScheduleEventCommandConfig,
  ScheduleEventDeviceConfig,
} from '@thingslog/repositories';
import { EventConfigFactory } from './EventConfigFactory';

export class ModbusReadRegisterFactory implements EventConfigFactory {
  public create(deviceNumbers: string[]): ModbusReadRegisterScheduleEventCommandConfig {
    return {
      '@type': 'MODBUS_READ_REGISTER',
      deviceCommand: 'MODBUS',
      modbusCommandTag: '3',
      deviceNumbers,
      sensorIndex: 0,
      slaveDeviceNumber: '',
    };
  }
}
